import { Component, ViewChild, OnInit} from '@angular/core';
import { BsModalComponent } from 'ng2-bs3-modal';

/*Services */
import { TariffService } from '@services/tariff.services';
import { Tariff } from '@models';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'tariff-modal',
    templateUrl: './tariff-modal.component.html'
})

export class TariffModalComponent  implements OnInit {

    @ViewChild('tariffModal') tariffModal: BsModalComponent;
    paymentUrl = null;
    errorText = null;
    constructor(
      private tariffService: TariffService
    ) {}

    ngOnInit() {

    }

    open(tariff: Array<Tariff>) {
        this.errorText = null;
        this.paymentUrl = null;
        this.tariffModal.open();
        this.getPaymentUrl(tariff);
    }
    getPaymentUrl(tariff: Array<Tariff>) {
      this.tariffService.getTariffUrlPayment(tariff)
        .subscribe( response => {
          if ( response.paymentUri && response.paymentUri.length > 0) {
            this.paymentUrl = response.paymentUri;
          }
        },
        error => {
            let errorTariff = 'Ошибка при получении ссылки на оплату тарифа.';
            if (error.error.errorMessage) {
              errorTariff = error.error.errorMessage;
            }
            this.errorText = errorTariff;
            console.log(error);
        });
    }
    close() {
      this.tariffModal.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/view/modal/tariff-modal/tariff-modal.component.ts